// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep swiper.mir-card-body-photo-swiper .swiper-pagination {
  top: 10px;
}

.mir-card {
  display: flex;
  flex-direction: column;
  padding: 20px;
  /*     border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3); */
}
.mir-card .white-chip {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.87);
}
.mir-card .white-chip ion-icon {
  color: rgba(255, 255, 255, 0.87);
}
.mir-card-body-photo > swiper.mir-card-body-photo-swiper img {
  border-radius: 8px;
}
.mir-card-footer {
  z-index: 1001;
  margin-top: -52px;
  padding: 10px;
  border-radius: 0 0px 12px 12px;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6));
}
.mir-card-footer-connection {
  display: flex;
  flex-direction: row;
}
.mir-card-footer-connection-mirMessage {
  color: rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.87);
  padding: 8px;
  font-size: 14px;
}
.mir-card-footer-connection-mirPhoto > ion-chip {
  margin: 0;
}

app-image-shell.friend-picture {
  --image-shell-border-radius: var(--page-border-radius);
}

.loading-shell {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  /* Para crear un contenedor cuadrado */
  background-color: #f5f5f5;
  /* Color de fondo del shell */
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading {
  width: 100%;
  height: 100%;
  background-color: #ccc;
  /* Color gris para el efecto de carga */
  opacity: 0.4;
  /* Opacidad para el efecto de carga */
  animation: pulse 1.5s infinite;
}`, "",{"version":3,"sources":["webpack://./src/app/components/posts/new-mirador/new-mirador.component.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EAWA;4CAAA;AARJ;AADI;EACI,qCAAA;EACA,gCAAA;AAGR;AAAI;EACI,gCAAA;AAER;AAeQ;EACI,kBAAA;AAbZ;AAkBI;EACI,aAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,uEAAA;AAhBR;AAkBQ;EACI,aAAA;EACA,mBAAA;AAhBZ;AAmBY;EACI,qDAAA;EACA,YAAA;EACA,eAAA;AAjBhB;AAqBgB;EACI,SAAA;AAnBpB;;AA0BA;EACI,sDAAA;AAvBJ;;AA0BA;EACI,WAAA;EACA,SAAA;EACA,oBAAA;EACA,sCAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAvBJ;;AA0BA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,YAAA;EACA,qCAAA;EACA,8BAAA;AAvBJ","sourcesContent":[":host ::ng-deep swiper.mir-card-body-photo-swiper .swiper-pagination {\r\n    top: 10px;\r\n}\r\n\r\n.mir-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 20px;\r\n\r\n    .white-chip {\r\n        background: rgba(white, 0.12);\r\n        color: rgba(white, 0.87);\r\n    }\r\n\r\n    .white-chip ion-icon {\r\n        color: rgba(white, 0.87);\r\n    }\r\n\r\n    /*     border-radius: 10px;\r\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3); */\r\n\r\n    // &-header {\r\n    //     z-index: 1001;\r\n    //     margin-bottom: -60px;\r\n    //     padding: 10px;\r\n    //     background: linear-gradient(to top, transparent, rgba(0, 0, 0, 0.3));\r\n    //     display: flex;\r\n    //     flex-direction: row-reverse;\r\n    // }\r\n\r\n    &-body-photo>swiper.mir-card-body-photo-swiper {\r\n\r\n        img {\r\n            border-radius: 8px;\r\n        }\r\n    }\r\n\r\n\r\n    &-footer {\r\n        z-index: 1001;\r\n        margin-top: -52px;\r\n        padding: 10px;\r\n        border-radius: 0 0px 12px 12px;\r\n        background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6));\r\n\r\n        &-connection {\r\n            display: flex;\r\n            flex-direction: row;\r\n\r\n\r\n            &-mirMessage {\r\n                color: rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.87);\r\n                padding: 8px;\r\n                font-size: 14px;\r\n            }\r\n\r\n            &-mirPhoto {\r\n                >ion-chip {\r\n                    margin: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\napp-image-shell.friend-picture {\r\n    --image-shell-border-radius: var(--page-border-radius);\r\n}\r\n\r\n.loading-shell {\r\n    width: 100%;\r\n    height: 0;\r\n    padding-bottom: 100%;\r\n    /* Para crear un contenedor cuadrado */\r\n    background-color: #f5f5f5;\r\n    /* Color de fondo del shell */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.loading {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: #ccc;\r\n    /* Color gris para el efecto de carga */\r\n    opacity: 0.4;\r\n    /* Opacidad para el efecto de carga */\r\n    animation: pulse 1.5s infinite;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
